import { render, staticRenderFns } from "./Commodities.vue?vue&type=template&id=25a62454&scoped=true&"
import script from "./Commodities.vue?vue&type=script&lang=js&"
export * from "./Commodities.vue?vue&type=script&lang=js&"
import style0 from "./Commodities.vue?vue&type=style&index=0&id=25a62454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a62454",
  null
  
)

export default component.exports